import { updateCompletionStatus, updateCompletionStatusPwr, updateWorkRequestStatus, updatePaperWorkRequestStatus } from 'gql/mutations'
import React from 'react'

type WorkRequestStatusCount = {
  record: any
  source?: string
}

export const getWorkRequestStatusCount = (record: any, source?: string) => {
  let reviewed_count: number = 0,
    approved_count: number = 0,
    total_to_review: number = 0,
    total_to_approve: number = 0,
    rejected_count: number = 0,
    retired_count: number = 0,
    for_review_count: number = 0,
    for_approval_count: number = 0,
    total_valid_questions: number = 0,
    total_deleted: number = 0,
    rejected_approve_count: number = 0,
    rejected_approve_count_creator: number = 0

  record?.questions?.length > 0 &&
    record?.questions?.map((item: any) => {
      if (item?.active === 'false') {
        total_deleted++
      }
      if (item?.status === 'Rejected at Review' || item?.status === 'Open (Require Amending') {
        rejected_count++
      }
      if (item?.status === 'For Review (Require Amending)') {
        rejected_approve_count++
      }
      if (item?.status === 'Rejected at Approval') {
        rejected_approve_count_creator++
      }
      if (
        item?.status === 'For Review' ||
        item?.status === 'For Approval' ||
        item?.status === 'Published' ||
        item?.status === 'Rejected at Review' ||
        item?.status === 'Rejected at Approval' ||
        item?.status === 'For Review (Require Amending)' ||
        item?.status === 'Open (Require Amending'
      ) {
        total_to_review++
      }
      if (item?.status === 'For Approval' || item?.status === 'Published' || item?.status === 'Rejected at Approval') {
        total_to_approve++
      }
      if (item?.status === 'For Approval' || item?.status === 'Published') {
        reviewed_count++
      }
      if (item?.status === 'Published') {
        approved_count++
      }
      if (item?.status === 'Retired') {
        retired_count++
      }
      if (item?.status === 'For Review') {
        for_review_count++
      }
      if (item?.status === 'For Approval') {
        for_approval_count++
      }
      if (
        item?.status !== 'Rejected at Review' &&
        item?.status !== 'Rejected at Approval' &&
        item?.status !== 'Retired' &&
        item?.active !== 'false'
      ) {
        total_valid_questions++
      }
    })
  let creator_total_count = record?.questions?.length - rejected_count - total_deleted - rejected_approve_count_creator
  let reviewer_total_count = total_to_approve - rejected_approve_count
  let approver_total_count = approved_count
  let overall_count = parseFloat(`${(creator_total_count * 75 + reviewer_total_count * 15 + approver_total_count * 10) / record?.count}`)
  console.log('total_count', approver_total_count)
  if (approver_total_count === record?.count) {
    overall_count = 100

    //
    if(record?.id!==undefined){
    if (source === 'paper_work_request' ) {
      updateCompletionStatusPwr(record?.id, overall_count).then(() => {
        updatePaperWorkRequestStatus(record?.id, 'Closed')
      })
    } else {
      updateCompletionStatus(record?.id, overall_count).then(() => {
        updateWorkRequestStatus(record?.id, 'Closed')
        // alert(2)
      })
    }
  }
  } else {
    if (overall_count >= 100) {
      overall_count = 99
    }
    if(record?.id!==undefined){
    if (source === 'paper_work_request') {
      updateCompletionStatusPwr(record?.id, overall_count).then(() => {
        updatePaperWorkRequestStatus(record?.id, 'Closed')
      })
    } else {
      updateCompletionStatus(record?.id, overall_count).then(() => {
        updateWorkRequestStatus(record?.id, record?.status)
        // alert(3)
      })
    }
  }
  }

  // let overall_count:number =
  //   ((((record?.questions?.length - rejected_count - total_deleted-rejected_approve_count_creator) * 0.75)) / record?.count + ((total_to_approve-rejected_approve_count) * 0.15) / record?.count + (approved_count * 0.1) / record?.count) * 100

  return {
    total_to_review,
    total_to_approve,
    reviewed_count,
    approved_count,
    rejected_count,
    overall_count,
    retired_count,
    for_review_count,
    for_approval_count,
    total_valid_questions,
    total_deleted,

    rejected_approve_count,
    rejected_approve_count_creator,
  }
}
